// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainerMulti":"PartnerAdAccount-dropdownContainerMulti-qUfdNT","dropdownContainerSingle":"PartnerAdAccount-dropdownContainerSingle-2Hb6Us"};